import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'underscore';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
import { ApiService } from '../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from '../../services/storage.service';
import { V } from '@angular/core/src/render3';

@Component({
  selector: 'app-modal-adicionar-item-portfolio',
  templateUrl: './modal-adicionar-item-portfolio.component.html',
  styleUrls: ['./modal-adicionar-item-portfolio.component.scss'],
})
export class ModalAdicionarItemPortfolioComponent implements OnInit {

  @Input() corPrimaria: string;
  @Input() servicosSistema: any;
  @Input() uf: any;
  @Output() fecharModal = new EventEmitter();
  servicoIdSelecionado: any;
  servicoSelecionado: any;
  id: any;
  idNotifica: any;
  operacaoSolicitadas: any;
  operacoes: any;
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'noOperacao',
    selectAllText: 'Selecionar todos',
    unSelectAllText: 'limpar',
    noDataAvailablePlaceholderText: 'Nenhuma operação disponivel',
    allowSearchFilter: false,
    closeDropDownOnSelection: true
  };
  state: any = 0;
  municipio: any = 0;
  municipioSelecionado: any;
  municipios = [];
  servicosEsusve: any;
  servicosEstadoSelecionado: any;
  servicosEsusveFiltrado: any;
  servicosNotifica: any;
  servicosNotificaFiltrado: any;
  states: any;
  currentApp: any;
  disableState = false;

  constructor(private toast: ToastrService,
    private api: ApiService,
    private loading: NgxSpinnerService,
    private storage: StorageService) {
      this.currentApp = JSON.parse(this.storage.getCurrentApp());
    }

  ngOnInit() {
    this.load();
  }

  async load() {
    this.loading.show();
    this.states = await this.api.getStates();

    if(this.uf) {
      this.disableState = true;
      this.state = this.uf;
      this.selectState();
      this.selectStateNotifica();
    }
    await this.loadServicosEsusve();
    await this.loadServicosNotifica();

    if (this.servicosSistema.length && this.currentApp.portifolio == 22) {
      await this.loadServicos();
      
    }

    this.loading.hide();
}

async loadServicos() {
  this.servicosSistema = this.servicosSistema.filter(servico => {
    if (servico.noServico.length === 19) {
      const split = servico.noServico.split('-');
      return this.state.toLowerCase() === split[2];
    } else if (servico.noServico.length > 19) {}
    const split = servico.noServico.split('-');
    return this.state.toLowerCase() === split[3];
  });
}


  async selectState() {
    this.loading.show();
    this.servicosEsusveFiltrado = this.servicosEsusve;

    this.municipioSelecionado = null;
    this.municipio = null;
    if(this.state) {
      let index = this.states.find((item) => (item.sigla === this.state));
      const municipios: any = await this.api.getMunicipio(index);
      this.municipios = municipios;
      this.servicosEsusveFiltrado = await this.filtrarServico();
      this.servicosEstadoSelecionado = this.servicosEsusveFiltrado;
    }

    this.loading.hide();
  }

  async selectMunicipio() {
    this.loading.show();

    if(!this.municipio) {
      this.servicosEsusveFiltrado = this.servicosEstadoSelecionado;
    } else {
      this.municipioSelecionado = this.municipios.find((item) => (item.codigo === this.municipio));
      this.servicosEsusveFiltrado = await this.filtrarServico();
    }

    this.loading.hide();
  }

  async selectStateNotifica() {
    this.loading.show();
    this.servicosNotificaFiltrado = this.servicosNotifica;

    this.municipioSelecionado = null;
    this.municipio = null;
    if(this.state) {
      let index = this.states.find((item) => (item.sigla === this.state));
      const municipios: any = await this.api.getMunicipio(index);
      this.municipios = municipios;
      this.servicosNotificaFiltrado = await this.filtrarServicoNotifica();
      this.servicosEstadoSelecionado = this.servicosNotificaFiltrado;
    }

    this.loading.hide();
  }

  async selectMunicipioNotifica() {
    this.loading.show();

    if(!this.municipio) {
      this.servicosNotificaFiltrado = this.servicosEstadoSelecionado;
    } else {
      this.municipioSelecionado = this.municipios.find((item) => (item.codigo === this.municipio));
      this.servicosNotificaFiltrado = await this.filtrarServicoNotifica();
    }

    this.loading.hide();
  }

  async loadServicosEsusve() {
    this.loading.show();

    this.servicosEsusve = await this.api.getServicoEsusve();
    console.log(this.servicosEsusve)

    this.servicosEsusve = await this.servicosEsusve.filter((item) => {
      return (item.IS_ACTIVE == true);
    });



    this.loading.hide();
  }


  async loadServicosNotifica() {
    this.loading.show();

    this.servicosNotifica = await this.api.getServicoNotifica();
    console.log('servicosNotifica', this.servicosNotifica)

    this.servicosNotificaFiltrado = this.servicosNotifica.filter((item) => {
      return (item.IS_ACTIVE == true);
    });;

    this.loading.hide();
  }

  async filtrarServico() {
    console.log(this.servicosEsusve)
    return await this.servicosEsusve.filter((item) => {
      if (this.state && !this.municipioSelecionado) {
        return (item.UF.toString().toLowerCase() == this.state.toString().toLowerCase() && item.IS_ACTIVE == true && item.NO_OPERACAO == 'GET')
      }
      else if(this.state && this.municipioSelecionado && item.MUNICIPIO) {
        return (item.UF.toString().toLowerCase() == this.state.toString().toLowerCase() &&
        this.removeAcentos(item.MUNICIPIO.toString().toLowerCase()) == this.municipioSelecionado.nome.toString().toLowerCase())
        && item.IS_ACTIVE == true && item.NO_OPERACAO == 'GET';
      }
      else {
        return;
      }
    })
  }

  async filtrarServicoNotifica() {
    return await this.servicosNotifica.filter((item) => {
      if (this.state && !this.municipioSelecionado) {
        return (item.UF.toString().toLowerCase() == this.state.toString().toLowerCase() && item.IS_ACTIVE == true)
      }
      else if(this.state && this.municipioSelecionado && item.MUNICIPIO) {
        return (item.UF.toString().toLowerCase() == this.state.toString().toLowerCase() &&
        this.removeAcentos(item.MUNICIPIO.toString().toLowerCase()) == this.municipioSelecionado.nome.toString().toLowerCase())
        && item.IS_ACTIVE == true;
      }
      else {
        return;
      }
    })
  }


  removeAcentos(text) {
    text = text.toLowerCase();
    text = text.replace(new RegExp('[ÁÀÂÃ]','gi'), 'a');
    text = text.replace(new RegExp('[ÉÈÊ]','gi'), 'e');
    text = text.replace(new RegExp('[ÍÌÎ]','gi'), 'i');
    text = text.replace(new RegExp('[ÓÒÔÕ]','gi'), 'o');
    text = text.replace(new RegExp('[ÚÙÛ]','gi'), 'u');
    text = text.replace(new RegExp('[Ç]','gi'), 'c');
    return text;
  }

  async selectServEsus() {
    let item = this.servicosEsusveFiltrado.find((item) => (item.CO_SEQ_SERVICO === parseInt(this.servicoIdSelecionado)));
    this.servicoSelecionado = [{...item, noOperacao: item.NO_OPERACAO, id: item.CO_SEQ_OPERACAO}]
     // {"CO_SEQ_SERVICO": 5958, "NO_SERVICO": "_search/scroll", noOperacao: 'POST', id: 6103}];
  }

  async selectServ() {
    let item = this.servicosSistema.find((item) => (item.id === parseInt(this.servicoIdSelecionado)));
    item = item.operacoes[0];
    this.servicoSelecionado = [{...item, noOperacao: item.noOperacao, id: item.id}];
  }


  async seleciona() {
    this.operacoes = [];
    this.operacaoSolicitadas = null;
    if (this.id) {
      let index = this.servicosSistema.findIndex((item) => (item.id === parseInt(this.id)));
      this.operacoes = this.servicosSistema[index].operacoes;
    }
  }

  async selecionaNotifica() {
    this.operacoes = [];
    this.operacaoSolicitadas = null;
    if (this.id) {
      let index = this.servicosNotifica.findIndex((item) => (item.CO_SEQ_SERVICO === parseInt(this.id)));
      let item = this.servicosNotifica[index];
      this.operacoes = [{...item, noOperacao: item.NO_OPERACAO, id: item.CO_SEQ_OPERACAO}]
       // {"CO_SEQ_SERVICO": 5959, "NO_SERVICO": "_search/scroll", noOperacao: 'POST', id: 6104}];
    }
  }

  fechar(bol) {
    this.fecharModal.emit();
  }


  isOptionDisabled(servico) {
    return servico.noServico.toLowerCase().indexOf('pix') >= 0;
  }

  adicionar() {


    if (!this.operacaoSolicitadas || this.operacaoSolicitadas.length === 0) {
      this.toast.error('Preencha o campo operação');
      return;
    }
    let getMethod = false;
    let postMethod = false;
    const service = [];
    let operacoesPort = [];
    for (let operacaoID of this.operacaoSolicitadas) {
      if (operacaoID.noOperacao == 'GET') {
        getMethod = true;
      }
      if (operacaoID.noOperacao == 'POST') {
        postMethod = true;
      }
      operacoesPort.push({
        id: operacaoID.id,
        name: operacaoID.noOperacao
      });
    }
    if (this.servicoSelecionado || this.servicosNotifica || this.servicoIdSelecionado) {
      if (getMethod == true) {
        if (this.currentApp.portifolio == 8) {
          for (let item of this.servicosEsusve ) {
              if (this.servicoSelecionado[0].NO_SERVICO == item.NO_SERVICO) {
              service.push({
                  id: item.CO_SEQ_SERVICO,
                  name: item.NO_SERVICO,
                  operacaoSolicitadas: [{
                    id: item.CO_SEQ_OPERACAO,
                    name: item.NO_OPERACAO
                  }]
              })
            }
          }
        }


        if (this.currentApp.portifolio == 22) {
          const operacoes = [];
          this.operacaoSolicitadas.forEach(operacao => {
            const op = {
              id: operacao.id,
              name: operacao.noOperacao
            };
            operacoes.push(op);
          });
          for (let item of this.servicosSistema ) {
              if (item.id === parseInt(this.servicoIdSelecionado)) {
              service.push({
                  id: item.id,
                  name: item.noServico,
                  operacaoSolicitadas: operacoes
              });
            }
          }
        }



        if (this.currentApp.portifolio == 13) {
          let index = this.servicosNotifica.findIndex((item) => (item.CO_SEQ_SERVICO === parseInt(this.id)));
          for (let item of this.servicosNotifica ) {
              if (this.servicosNotifica[index].NO_SERVICO == item.NO_SERVICO) {
              service.push({
                  id: item.CO_SEQ_SERVICO,
                  name: item.NO_SERVICO,
                  operacaoSolicitadas: [{
                    id: item.CO_SEQ_OPERACAO,
                    name: item.NO_OPERACAO
                  }]
              })
            }
          }
        }
      }
      if (postMethod == true) {
        service.push({
          id: 5958,
          name: '_search/scroll',
          operacaoSolicitadas: [{
            id: 6103,
            name: 'POST'
          }]
        });
      }
      this.fecharModal.emit(service);

      return;
    }

    if (!this.id) {
      this.toast.error('Preencha o campo serviço');
      return;
    }
    let name;
    if (this.currentApp.portifolio != 13) {
      const index = this.servicosSistema.findIndex((item) => (item.id === parseInt(this.id)));
      name = this.servicosSistema[index].noServico;
    } else {
      const index = this.servicosNotifica.findIndex((item) => (item.CO_SEQ_SERVICO === parseInt(this.id)));
      name = this.servicosNotifica[index].NO_SERVICO;
    }
    const operacoes = _.map(this.operacaoSolicitadas , (operacaoID: any) => {
      return {
        id: operacaoID.id,
        name: operacaoID.noOperacao
      };
    });
    this.fecharModal.emit({
      id: parseInt(this.id),
      name: name,
      operacaoSolicitadas: operacoes
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-adicionar-item-portfolio/modal-adicionar-item-portfolio.component.ts